export default __webpack_public_path__ + "static/media/EMlogo.6572d306.svg";